// -----------------------------------------------------------------------------
export class OWGames {
  // ---------------------------------------------------------------------------
  public static getRunningGameInfo(): Promise<overwolf.games.RunningGameInfo> {
    return new Promise(resolve => {
      overwolf.games.getRunningGameInfo(resolve);
    });
  }

  // ---------------------------------------------------------------------------
  public static classIdFromGameId(gameId: number): number {
    const classId = Math.floor(gameId / 10);
    return classId;
  }

  // ---------------------------------------------------------------------------
  public static async getRecentlyPlayedGames(limit = 3):
    Promise<number[]|null> {

    return new Promise(resolve => {
      if (!overwolf.games.getRecentlyPlayedGames) {
        return resolve(null);
      }

      overwolf.games.getRecentlyPlayedGames(limit, result => {
        resolve(result.games);
      });
    });
  }

  // ---------------------------------------------------------------------------
  public static async getGameDBInfo(gameClassId: number):
    Promise<overwolf.games.GetGameDBInfoResult> {

    return new Promise(resolve => {
      overwolf.games.getGameDBInfo(gameClassId, resolve);
    });
  }
}
